import React from 'react';

const NavBarContext = React.createContext({
  togglePopover: () => null,
  getPopoverClass: () => null,
  handleLogout: () => null,
});

export default NavBarContext;
